<template>
  <el-dialog
    title="阅卷"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @close="dialogClose"
    custom-class="narjubg_custom_dialog"
    top="30px"
  >
    <div
      ref="dialogContainer"
      style="overflow-y: auto; padding: 0px 10px 0px 10px"
      :style="formBodyStyle"
    >
      <el-row class="wj_main">
        <el-col :span="24">
          <div class="wj_body">
            <div class="wj_body_head">
              <h1>{{ answerPaper.QuestionnaireName }}</h1>
            </div>
            <div class="wj_body_head_info">
              <div class="wj_body_head_info_left">
                <span class="wj_body_head_info_left_item">
                  题目数量：{{ answerPaper.QuestinsNumber }}
                </span>
                <span
                  v-if="answerPaper.QuestionnaireType === 1"
                  class="wj_body_head_info_left_item"
                >
                  总分：{{ answerPaper.TotalScore }}分
                </span>
                <span
                  v-if="
                    answerPaper.QuestionnaireType === 1 &&
                    answerPaper.IsSetPassScore
                  "
                  class="wj_body_head_info_left_item"
                >
                  通过线：{{ answerPaper.PassScore }}分
                </span>
              </div>
              <div
                class="wj_body_head_info_right"
                v-if="answerPaper.QuestionnaireType === 1"
              >
                <span
                  class="wj_body_head_info_right_item"
                  v-if="answerPaper.IsSubmit"
                  style="color: #67c23a"
                >
                  已交卷
                </span>
                <span
                  class="wj_body_head_info_right_item"
                  v-if="!answerPaper.IsSubmit"
                >
                  未交卷
                </span>
              </div>
            </div>
            <el-row>
              <el-col
                v-if="
                  answerPaper.QuestionnaireType === 1 && answerPaper.IsSubmit
                "
                class="wj_score_box"
                :xs="{ span: 24 }"
                :sm="{ span: 18, offset: 3 }"
                :md="{ span: 16, offset: 4 }"
                :lg="{ span: 16, offset: 4 }"
                :xl="{ span: 12, offset: 6 }"
              >
                <div class="wj_score_item">
                  <div class="wj_score_item_content">
                    <div class="">
                      {{ answerPaper.AnswerRightNumber }}
                    </div>
                    <span>答对</span>
                  </div>
                  <div class="wj_score_item_bottom">
                    共 {{ answerPaper.QuestinsNumber }} 题
                  </div>
                </div>
                <div class="wj_score_item">
                  <div class="wj_score_item_content">
                    <div
                      class="wj_score_item_font"
                      :style="[
                        {
                          color:
                            answerPaper.AnswerTotalScore >=
                            answerPaper.PassScore
                              ? '#FF6A00'
                              : 'red'
                        }
                      ]"
                    >
                      {{ answerPaper.AnswerTotalScore }}
                    </div>
                    <span
                      ><i
                        class="iconfont icon-fenshudixian"
                        :style="[
                          {
                            color:
                              answerPaper.AnswerTotalScore >=
                              answerPaper.PassScore
                                ? '#FF6A00'
                                : 'red'
                          }
                        ]"
                      ></i
                    ></span>
                  </div>
                  <div class="wj_score_item_bottom">
                    总分
                    {{ answerPaper.TotalScore }}
                  </div>
                </div>
              </el-col>
            </el-row>
            <div
              class="wj_element_box"
              v-for="(element, index) in answerPaper.ElementItems"
              :key="index"
            >
              <div
                class="wj_element"
                :style="[
                  {
                    border: element.NoAnswer
                      ? '2px solid #E6A23C'
                      : '2px solid #fff'
                  }
                ]"
              >
                <div
                  class="wj_element_title_all wj_element_title_duanluo"
                  v-if="element.ElementType === 1"
                  :style="{
                    marginLeft: element.ElementType === 1 ? '-36px' : '0px'
                  }"
                >
                  <span class="show_index">{{ element.ShowIndex }}、</span>
                  <div class="wj_element_title" v-html="element.Title"></div>
                </div>

                <div
                  class="wj_element_title_all wj_element_title_question_16"
                  v-if="element.ElementType === 2 && element.QuestionType !== 4"
                >
                  <span class="show_index">{{ element.ShowIndex }}.</span>
                  <div
                    class="wj_element_title"
                    v-html="
                      '<span class=\'element_type\'>【' +
                      element.QuestionTypeText +
                      '】</span>' +
                      element.QuestionStem
                    "
                  ></div>
                  <!-- <div class="wj_element_title">
                    <div v-html="element.QuestionStem"></div>
                    <span
                      class="element_score"
                      v-if="answerPaper.QuestionnaireType === 1"
                    >
                      （{{ element.QuestionScore }}分）
                    </span>
                  </div> -->
                </div>

                <div
                  class="wj_element_title_all wj_element_title_question_16"
                  v-if="element.ElementType === 2 && element.QuestionType === 4"
                >
                  <span class="show_index">{{ element.ShowIndex }}.</span>
                  <div
                    class="wj_element_title"
                    v-html="
                      '<span class=\'element_type\'>【' +
                      element.QuestionTypeText +
                      '】</span>' +
                      getBlankBody(element, index)
                    "
                  ></div>
                  <!-- <div class="wj_element_title">
                    <div
                      class="questionStem"
                      v-html="getBlankBody(element, index)"
                    ></div>
                    <span
                      class="element_score"
                      v-if="answerPaper.QuestionnaireType === 1"
                    >
                      （{{ element.QuestionScore }}分）
                    </span>
                  </div> -->
                </div>

                <div
                  class="wj_element_option_box"
                  v-if="
                    element.QuestionType === 1 || element.QuestionType === 3
                  "
                >
                  <div
                    class="wj_element_option_item"
                    v-for="(optionItem, optionIndex) in element.OptionItems"
                    :key="optionIndex"
                  >
                    <el-radio
                      v-model="element.SelectOptionId"
                      :label="optionItem.AnswerPaperOptionId"
                      class="choice"
                      :disabled="
                        element.SelectOptionId !==
                        optionItem.AnswerPaperOptionId
                      "
                    >
                      <div class="choice_inner">
                        <span class="choice_index">{{
                          getOptionIndex(
                            answerPaper.OptionSerialNumberType,
                            optionIndex
                          )
                        }}</span>
                        <div
                          class="choice_content"
                          v-html="optionItem.Content"
                        ></div>
                      </div>
                    </el-radio>
                  </div>
                </div>

                <div
                  class="wj_element_option_box"
                  v-if="element.QuestionType === 2"
                >
                  <div
                    class="wj_element_option_item"
                    v-for="(optionItem, optionIndex) in element.OptionItems"
                    :key="optionIndex"
                  >
                    <el-checkbox
                      v-model="optionItem.Selected"
                      class="choice"
                      :disabled="!optionItem.Selected"
                      @change="optionCheckboxChange(optionItem)"
                    >
                      <div class="choice_inner">
                        <span class="choice_index">{{
                          getOptionIndex(
                            answerPaper.OptionSerialNumberType,
                            optionIndex
                          )
                        }}</span>
                        <div
                          class="choice_content"
                          v-html="optionItem.Content"
                        ></div>
                      </div>
                    </el-checkbox>
                  </div>
                </div>

                <div v-if="element.QuestionType === 5">
                  <el-input
                    type="textarea"
                    :rows="element.TextHeight"
                    :minlength="element.MinWordNum"
                    :maxlength="element.MaxWordNum"
                    :style="[
                      {
                        width:
                          element.TextWidth == 0
                            ? '100%'
                            : element.TextWidth + 'px'
                      }
                    ]"
                    v-model="element.AnswerElementAnswer"
                    disabled
                  >
                  </el-input>
                </div>
                <div
                  class="judge_question_correct"
                  v-if="
                    answerPaper.QuestionnaireType === 1 &&
                    element.ElementType === 2 &&
                    answerPaper.IsSubmit &&
                    element.IsValidScore
                  "
                >
                  <div
                    class="judge_question_correct_left"
                    v-if="!element.IsManual"
                  >
                    <span v-if="element.AnswerRight">
                      <i class="el-icon-circle-check"></i>
                      回答正确
                    </span>
                    <span
                      v-if="!element.AnswerRight"
                      class="judge_question_correct_error"
                    >
                      <i class="el-icon-circle-close"></i>
                      回答错误
                    </span>
                    <span
                      :style="[
                        { color: element.AnswerRight ? '#67C23A' : 'red' }
                      ]"
                    >
                      +{{ element.AnswerElementScore }}分
                    </span>
                    <span style="color: #67c23a">
                      （分值：{{ element.QuestionScore }}分）
                    </span>
                  </div>
                  <div
                    class="judge_question_correct_left"
                    v-if="element.IsManual"
                  >
                    <span class="judge_question_correct_manual">
                      <i class="el-icon-info"></i>
                      人工评分
                    </span>
                    <span style="color: #409eff">
                      +{{ element.AnswerElementScore }}分
                    </span>
                    <span style="color: #67c23a">
                      （分值：{{ element.QuestionScore }}分）
                    </span>
                  </div>
                  <el-popover
                    placement="bottom-end"
                    width="265"
                    trigger="click"
                    :ref="'popover_' + element.AnswerPaperElementId"
                    v-if="answerPaper.IsSubmit"
                  >
                    <div class="manual_scoring_box">
                      <!-- <div
                        v-for="s in element.QuestionScore"
                        :key="s"
                        class="manual_scoring_div_item"
                        v-show="false"
                      >
                        <el-button
                          type="primary"
                          plain
                          size="mini"
                          @click="
                            markingAnswerPaper(
                              'popover_' + element.AnswerPaperElementId,
                              element.AnswerPaperElementId,
                              s - 0.5
                            )
                          "
                        >
                          {{ s - 0.5 }}
                        </el-button>
                        <el-button
                          type="primary"
                          plain
                          size="mini"
                          @click="
                            markingAnswerPaper(
                              'popover_' + element.AnswerPaperElementId,
                              element.AnswerPaperElementId,
                              s
                            )
                          "
                        >
                          {{ s }}
                        </el-button>
                      </div> -->
                      <!-- <div class="manual_scoring_div_item" v-show="false">
                        <el-button
                          type="primary"
                          plain
                          size="mini"
                          @click="
                            markingAnswerPaper(
                              'popover_' + element.AnswerPaperElementId,
                              element.AnswerPaperElementId,
                              0
                            )
                          "
                        >
                          0
                        </el-button>
                      </div> -->
                      <el-input-number
                        v-model="element.setScore"
                        :min="0"
                        :max="element.QuestionScore"
                        :precision="0"
                        :step="1"
                        label="请输入分数"
                        :controls="false"
                        style="width: 180px"
                      ></el-input-number>
                      <el-button
                        type="primary"
                        plain
                        style="margin-left: 5px"
                        @click="
                          markingAnswerPaper(
                            'popover_' + element.AnswerPaperElementId,
                            element.AnswerPaperElementId,
                            element.setScore
                          )
                        "
                      >
                        评分
                      </el-button>
                    </div>
                    <el-link
                      slot="reference"
                      type="primary"
                      style="float: right"
                    >
                      <i class="el-icon-edit"></i>
                      人工评分
                    </el-link>
                  </el-popover>
                </div>

                <div
                  class="judge_question_correct"
                  v-if="
                    answerPaper.QuestionnaireType === 1 &&
                    element.ElementType === 1 &&
                    answerPaper.IsSubmit &&
                    element.IsManualMerge
                  "
                >
                  <div class="judge_question_correct_left">
                    <div
                      style="
                        height: 23px;
                        width: 8px;
                        background-color: #e6a23c;
                        float: left;
                      "
                    ></div>
                    <span
                      class="judge_question_correct_manual"
                      v-show="element.IsValidScore"
                    >
                      合并人工评分
                    </span>
                    <!-- <span
                      class="judge_question_correct_manual"
                      v-show="!element.IsValidScore"
                    >
                      单题人工评分
                    </span> -->
                    <span style="color: #409eff" v-show="element.IsValidScore">
                      +{{ element.AnswerElementScore }}分
                    </span>

                    <span style="color: #67c23a">
                      （合计分值：{{ element.ManualMergeMaxScore }}分）
                    </span>
                  </div>
                  <div class="judge_question_correct_right">
                    <el-link
                      type="primary"
                      style="float: left; margin-right: 15px"
                      v-show="element.IsValidScore"
                      @click="
                        closeManualMerge(
                          'popover_' + element.AnswerPaperElementId,
                          element.AnswerPaperElementId,
                          0,
                          false
                        )
                      "
                    >
                      <i class="el-icon-error"></i>
                      关闭合并评分
                    </el-link>
                    <el-popover
                      placement="bottom-end"
                      width="265"
                      trigger="click"
                      :ref="'popover_' + element.AnswerPaperElementId"
                      v-if="answerPaper.IsSubmit"
                    >
                      <div class="manual_scoring_box">
                        <el-input-number
                          v-model="element.setScore"
                          :min="0"
                          :max="element.ManualMergeMaxScore"
                          :precision="0"
                          :step="1"
                          label="请输入分数"
                          :controls="false"
                          style="width: 180px"
                        ></el-input-number>
                        <el-button
                          type="primary"
                          plain
                          style="margin-left: 5px"
                          @click="
                            markingAnswerPaperByManualMerge(
                              'popover_' + element.AnswerPaperElementId,
                              element.AnswerPaperElementId,
                              element.setScore,
                              true
                            )
                          "
                        >
                          评分
                        </el-button>
                      </div>
                      <el-link
                        slot="reference"
                        type="primary"
                        style="float: right"
                      >
                        <i class="el-icon-edit"></i>
                        合并人工评分
                      </el-link>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import answerPaperApi from '../../api/wj/answerPaper'
export default {
  name: 'EditElementTitle',
  components: {
  },
  data () {
    return {
      dialogFormVisible: false,
      formBodyStyle: { height: (window.innerHeight - 260) + 'px' },
      index: null,
      answerPaper: {},
      questionnaireId: null,
      answerPaperId: null,
      userId: null,
      isSubmit: false
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    openMarkingAnswerPaper: function (questionnaireId, answerPaperId, userId, index, isSubmit) {
      this.dialogFormVisible = true
      this.questionnaireId = questionnaireId
      this.answerPaperId = answerPaperId
      this.index = index
      this.userId = userId
      this.isSubmit = isSubmit
      this.getAnswerPaper()
      this.$nextTick(() => {
        this.$refs.dialogContainer.scrollTop = 0
      })
    },
    closeAnswerPaper: function () {
      this.fatherSubmitDialog(this.index, this.answerPaper.AnswerTotalScore, this.isSubmit)
      this.dialogFormVisible = false
    },
    dialogClose: function (done) {
      this.fatherSubmitDialog(this.index, this.answerPaper.AnswerTotalScore, this.isSubmit)
      this.dialogFormVisible = false
    },
    getAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getAnswerPaperByUserId({
        QuestionnaireId: this.questionnaireId,
        AnswerPaperId: this.answerPaperId,
        UserId: this.userId
      }).then(data => {
        _this.answerPaper = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        _this.dialogFormVisible = false
        return err
      })
    },
    getOptionIndex: function (optionSerialNumberType, optionIndex) {
      if (optionSerialNumberType === 2) {
        return String.fromCharCode(65 + optionIndex) + '、'
      } else if (optionSerialNumberType === 3) {
        return String.fromCharCode(65 + optionIndex).toLowerCase() + '、'
      } else {
        return optionIndex + 1 + '、'
      }
    },
    getBlankBody: function (element, elementIndex) {
      let questionStem = ''
      const stemArray = element.QuestionStem.split('___')

      let optionIndex = 0
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          questionStem = questionStem + item
          if (index < stemArray.length - 1) {
            let blankItemTextWidth = element.OptionItems[optionIndex].TextWidth + 'px'
            if (element.OptionItems[optionIndex].TextWidth === 0) {
              blankItemTextWidth = '100%'
            }
            const blankItemAnswer = element.OptionItems[optionIndex].Answer
            questionStem = questionStem + '<input type="text" id="' + element.AnswerPaperElementId.toLowerCase() + '_' + element.OptionItems[optionIndex].AnswerPaperOptionId.toLowerCase() + '" class="blankInput" style="width:' + blankItemTextWidth + '" value="' + blankItemAnswer + '" maxlength="' + element.OptionItems[optionIndex].MaxWordNum + '" minlength="' + element.OptionItems[optionIndex].MinWordNum + '" disabled />'
            optionIndex++
          }
        }
      })
      return questionStem
    },
    optionCheckboxChange: function (optionItem) {
      optionItem.Selected = true
    },
    markingAnswerPaper: function (tempRef, answerPaperElementId, markingScore) {
      const _this = this
      _this.openLoading()
      answerPaperApi.markingAnswerPaper({
        AnswerPaperId: this.answerPaperId,
        AnswerPaperElementId: answerPaperElementId,
        MarkingScore: markingScore
      }).then(data => {
        // const tempRef = 'popover_' + answerPaperElementId
        _this.$refs[tempRef][0].doClose()
        _this.getAnswerPaper()
        _this.$message({
          type: 'success',
          message: '评分成功！',
          customClass: 'custom_message'
        })
        _this.openLoading().close()
      }).catch(err => {
        _this.$message({
          type: 'success',
          message: '评分发生错误！',
          customClass: 'custom_message'
        })
        _this.openLoading().close()
        return err
      })
    },
    markingAnswerPaperByManualMerge: function (tempRef, answerPaperElementId, markingScore, isValidScore) {
      const _this = this
      _this.openLoading()
      answerPaperApi.markingAnswerPaperByManualMerge({
        AnswerPaperId: this.answerPaperId,
        AnswerPaperElementId: answerPaperElementId,
        MarkingScore: markingScore,
        IsValidScore: isValidScore
      }).then(data => {
        _this.$refs[tempRef][0].doClose()
        _this.getAnswerPaper()
        _this.$message({
          type: 'success',
          message: '评分成功！',
          customClass: 'custom_message'
        })
        _this.openLoading().close()
      }).catch(err => {
        _this.$message({
          type: 'success',
          message: '评分发生错误！',
          customClass: 'custom_message'
        })
        _this.openLoading().close()
        return err
      })
    },
    closeManualMerge: function (tempRef, answerPaperElementId, markingScore, isValidScore) {
      const _this = this
      _this.$confirm('确认关闭合并评分吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        _this.markingAnswerPaperByManualMerge(tempRef, answerPaperElementId, markingScore, isValidScore)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    }
  },
  created () {

  }
}
</script>
<style lang="less">
@import '../../assets/css/wj.css';
@media screen and (max-width: 992px) {
  .narjubg_custom_dialog {
    width: 98%;
  }
}
@media screen and (min-width: 992px) and (max-width: 1260px) {
  .narjubg_custom_dialog {
    width: 90%;
  }
}
@media screen and (min-width: 1260px) {
  .narjubg_custom_dialog {
    width: 70%;
  }
}
</style>
